import React, { useState } from 'react'
import { Button, Input, Select, Space } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import './index.less'
import { useAppDispatch } from '@/hooks'

type SEARCHCONDITON = 'AND' | 'OR' | ''
type SEARCHFIELD = '作者' | '作品' | '机构'

interface searchType {
  searchCondition: SEARCHCONDITON
  searchField: SEARCHFIELD
  searchValue: string
  isAccurate: boolean
}

interface searchKeyFormat {
  searchCondition: SEARCHCONDITON
  valueList: searchType[]
}

interface IAdvancedSearch {
  handleSearchKeyWord: (e: any) => void
}

const AdvancedSearch: React.FunctionComponent<IAdvancedSearch> = (props) => {
  const { handleSearchKeyWord } = props

  const _dispatch = useAppDispatch()

  //初始化搜索条件行
  const initCondition: searchType = {
    searchCondition: '',
    searchField: '作者',
    searchValue: '',
    isAccurate: true
  }

  //搜索条件集
  const [searchList, setSearchList] = useState<searchType[]>([{ ...initCondition }])

  const searchConditions = ['AND', 'OR']
  const searchFields = ['作者', '作品', '机构']
  const isAccurate = ['精确', '模糊']

  //删除搜索条件行
  const handleDelete = (index: number) => {
    const temp = [...searchList]
    temp.splice(index, 1)
    setSearchList(temp)
  }

  //增加搜索条件行
  const handleAdd = (index?: number, value?: searchType) => {
    console.log('handleAdd: ', value)
    let temp: searchType = {
      searchCondition: 'AND',
      searchField: '作者',
      searchValue: '',
      isAccurate: true
    }
    if (value) {
      temp = value
    }
    if (index === undefined) setSearchList([...searchList, temp])
    else {
      searchList.splice(index, 0, value as searchType)
      setSearchList([...searchList])
    }
  }

  //分割input内容
  const handleSplit = (index: number, inputText: string) => {
    const textList = inputText.split(/[\n|\s|\t]+/)
    textList.map((item: string, idx: number) => {
      if (item !== '') {
        const newSearchItem: searchType = {
          searchCondition: idx === 0 ? searchList[index].searchCondition : 'OR',
          searchField: searchList[index].searchField,
          searchValue: item,
          isAccurate: searchList[index].isAccurate
        }
        handleAdd(index + idx + 1, newSearchItem)
      }
    })
    handleDelete(index)
  }

  const handleConditionsChange = (index: number, value: string) => {
    searchList[index].searchCondition = value as SEARCHCONDITON
    setSearchList([...searchList])
  }

  const handleFieldChange = (index: number, value: string) => {
    searchList[index].searchField = value as SEARCHFIELD
    setSearchList([...searchList])
  }

  const handleInput = (index: number, value: string) => {
    searchList[index].searchValue = value
    setSearchList([...searchList])
  }

  const handleAccurateChange = (index: number, value: string) => {
    searchList[index].isAccurate = value === '精确' ? true : false
    setSearchList([...searchList])
  }

  //处理搜索逻辑
  const handleSearch = (handleSearchKeyWord: (e: any) => void) => {
    const unifiedList = {}
    const tempAttriList: SEARCHFIELD[] = []
    searchList.map((item: searchType) => {
      if (unifiedList[item.searchField] === undefined) {
        tempAttriList.push(item.searchField)
        const valueList: searchType[] = []
        valueList.push(item)
        const tempFormat: searchKeyFormat = {
          searchCondition: item.searchCondition,
          valueList: valueList
        }
        unifiedList[item.searchField] = tempFormat
      } else {
        unifiedList[item.searchField].valueList.push(item)
      }
    })

    let searchContent = ''
    tempAttriList.map((field: SEARCHFIELD) => {
      const tempValue: searchKeyFormat = unifiedList[field]
      searchContent += ' ' + tempValue.searchCondition + ' ' + field + ': '
      if (tempValue.valueList.length > 1) searchContent += '('
      tempValue.valueList.map((item: searchType, index: number) => {
        if (index > 0) searchContent += ' ' + item.searchCondition + ' '
        if (item.isAccurate === true) searchContent += '"'
        searchContent += item.searchValue
        if (item.isAccurate === true) searchContent += '"'
      })
      if (tempValue.valueList.length > 1) searchContent += ')'
    })
    handleSearchKeyWord(searchContent.trim())
  }

  //重置搜索条件
  const handleReset = () => {
    setSearchList([{ ...initCondition }])
  }
  return (
    <div className='advanced-search-container'>
      <div style={{ margin: '0 0 10px 90px' }}>
        <Space.Compact>
          <Select
            // defaultValue="作者"
            value={searchList[0].searchField}
            onChange={(value: string) => {
              handleFieldChange(0, value)
            }}
            options={searchFields.map((field: string) => ({ value: field, label: field }))}
            style={{ width: '80px' }}
            size='large'
          ></Select>
          <Input
            value={searchList[0].searchValue}
            onChange={(e) => {
              handleInput(0, e.target.value)
            }}
            onPressEnter={(e: any) => {
              handleSplit(0, e.target.value)
            }}
            size='large'
          />
          <Select
            value={searchList[0].isAccurate ? '精确' : '模糊'}
            onChange={(value: string) => {
              handleAccurateChange(0, value)
            }}
            options={isAccurate.map((i: string) => ({ value: i, label: i }))}
            style={{ width: '80px' }}
            size='large'
          ></Select>
        </Space.Compact>
        <PlusOutlined
          style={{ color: 'gray', cursor: 'pointer', margin: '0 5px' }}
          onClick={() => {
            handleAdd()
          }}
        />
      </div>
      {searchList.map((_search: searchType, index: number) => {
        if (index !== 0)
          return (
            <div key={index} style={{ marginBottom: '10px' }}>
              <Select
                value={searchList[index].searchCondition}
                onChange={(value: string) => {
                  handleConditionsChange(index, value)
                }}
                options={searchConditions.map((condition: string) => ({
                  value: condition,
                  label: condition
                }))}
                style={{ width: '80px', marginRight: '10px' }}
                size='large'
              ></Select>
              <Space.Compact>
                <Select
                  value={searchList[index].searchField}
                  onChange={(value: string) => {
                    handleFieldChange(index, value)
                  }}
                  options={searchFields.map((field: string) => ({ value: field, label: field }))}
                  style={{ width: '80px' }}
                  size='large'
                ></Select>
                <Input
                  value={searchList[index].searchValue}
                  onChange={(e) => {
                    handleInput(index, e.target.value)
                  }}
                  onPressEnter={(e: any) => {
                    handleSplit(index, e.target.value)
                  }}
                  size='large'
                />
                <Select
                  value={searchList[index].isAccurate ? '精确' : '模糊'}
                  onChange={(value: string) => {
                    handleAccurateChange(index, value)
                  }}
                  options={isAccurate.map((i: string) => ({ value: i, label: i }))}
                  style={{ width: '80px' }}
                  size='large'
                ></Select>
              </Space.Compact>
              <MinusOutlined
                style={{ color: 'gray', cursor: 'pointer', margin: '0 5px' }}
                onClick={() => {
                  handleDelete(index)
                  console.log('index: ', index)
                }}
              />
              <PlusOutlined
                style={{ color: 'gray', cursor: 'pointer', margin: '0 5px' }}
                onClick={() => {
                  handleAdd()
                }}
              />
            </div>
          )
      })}
      <div>
        <Button
          onClick={() => {
            handleReset()
          }}
          style={{ marginLeft: '90px', color: 'black' }}
        >
          重置条件
        </Button>
        <Button
          onClick={() => {
            handleSearch(handleSearchKeyWord)
          }}
          style={{ marginLeft: '30px', color: 'black' }}
        >
          检 索
        </Button>
      </div>
    </div>
  )
}

export default AdvancedSearch
